import { render } from "./VisorFile.vue?vue&type=template&id=a3cccfba&ts=true"
import script from "./VisorFile.vue?vue&type=script&lang=ts"
export * from "./VisorFile.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__